import { Eye, CheckCircle, XCircle, Trash } from '@phosphor-icons/react';
import { statusBadgeClass, statusLabel } from './AdminUI';

const canModerate = (status) => status === 'pending_verification' || status === 'form_submitted';

const RegistrationRow = ({ registration, index, onOpenDetail, onRequestAction }) => {
  const r = registration;
  return (
    <tr className="hover:bg-gray-50" data-testid={`registration-row-${index}`}>
      <td className="px-4 py-3 font-semibold text-gray-900 max-w-xs truncate">{r.tournament_name}</td>
      <td className="px-4 py-3 text-gray-600">{r.team_name || r.player_name || r.user_name}</td>
      <td className="px-4 py-3 text-gray-600 hidden md:table-cell">{r.phone}</td>
      <td className="px-4 py-3 text-gray-500 hidden lg:table-cell">{new Date(r.created_at).toLocaleDateString('en-IN')}</td>
      <td className="px-4 py-3">
        <span className={`text-[10px] px-2 py-1 rounded-full border font-semibold uppercase ${statusBadgeClass(r.status)}`}>
          {statusLabel(r.status)}
        </span>
      </td>
      <td className="px-4 py-3 text-right">
        <div className="inline-flex gap-1 flex-wrap justify-end">
          <button
            onClick={() => onOpenDetail(r.registration_id)}
            className="inline-flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-800 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
            data-testid={`view-registration-${index}`}
          >
            <Eye size={12} weight="bold" /> View
          </button>
          {canModerate(r.status) && (
            <>
              <button
                onClick={() => onRequestAction('approve', r)}
                className="inline-flex items-center gap-1 bg-green-50 hover:bg-green-100 text-green-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
                data-testid={`admin-approve-registration-${index}`}
              >
                <CheckCircle size={12} weight="bold" /> Approve
              </button>
              <button
                onClick={() => onRequestAction('reject', r)}
                className="inline-flex items-center gap-1 bg-red-50 hover:bg-red-100 text-red-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
                data-testid={`admin-reject-registration-${index}`}
              >
                <XCircle size={12} weight="bold" /> Reject
              </button>
            </>
          )}
          <button
            onClick={() => onRequestAction('delete', r)}
            className="inline-flex items-center gap-1 bg-red-50 hover:bg-red-100 text-red-700 px-2.5 py-1.5 rounded-lg text-[11px] font-semibold"
            data-testid={`admin-delete-registration-${index}`}
          >
            <Trash size={12} weight="bold" /> Delete
          </button>
        </div>
      </td>
    </tr>
  );
};

const RegistrationsTable = ({ registrations, onOpenDetail, onRequestAction }) => (
  <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-b border-gray-200">
          <tr>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Tournament</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Player/Team</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase hidden md:table-cell">Phone</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase hidden lg:table-cell">Date</th>
            <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Status</th>
            <th className="text-right px-4 py-3 font-semibold text-gray-700 text-xs uppercase">Actions</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {registrations.length === 0 ? (
            <tr><td colSpan={6} className="text-center py-10 text-gray-500">No registrations match your search</td></tr>
          ) : registrations.map((r, i) => (
            <RegistrationRow
              key={r.registration_id || `${r.tournament_id}-${r.user_id}`}
              registration={r}
              index={i}
              onOpenDetail={onOpenDetail}
              onRequestAction={onRequestAction}
            />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default RegistrationsTable;
